import script from "./form-two.vue?vue&type=script&setup=true&lang=js"
export * from "./form-two.vue?vue&type=script&setup=true&lang=js"

import "./form-two.vue?vue&type=style&index=0&id=07e841f2&scoped=true&lang=css"
import "./form-two.vue?vue&type=style&index=1&id=07e841f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e841f2"]])

export default __exports__